export var CONTRACT;
(function (CONTRACT) {
  CONTRACT[CONTRACT["SELLING"] = 0] = "SELLING";
  CONTRACT[CONTRACT["SALE"] = 1] = "SALE";
  CONTRACT[CONTRACT["RENT"] = 2] = "RENT";
  CONTRACT[CONTRACT["AUCTION"] = 3] = "AUCTION";
})(CONTRACT || (CONTRACT = {}));